module.exports = __webpack_public_path__ + "img/content6-7.6848dc3f.webp";